import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { catchError, map, Observable, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';
import { PollDataResponseModel } from './api.poll.model';

export class PollApi {
  private apiUrl = environment.API_URL;

  POLL = '/poll';
  QUESTION = '/question';

  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  getPollData(pollId: string): Observable<PollDataResponseModel> {
    return this.http
      .get<PollDataResponseModel>(`${this.apiUrl}${this.POLL}${this.QUESTION}/${pollId}`)
      .pipe(
        timeout(this.config.responseTimeout),
        map(response => {
          return response;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }
}
